import {Component, EventEmitter, Input, Output} from '@angular/core';

/** One choice in the period picker: the `Period` query value it sends, its label and its length in words. */
export interface AdminDashboardPeriodOption {
  key: string;
  label: string;
  /** The length of the period in words: the picker says "vs the previous <long>". */
  long: string;
}

/**
 * The Admin dashboard's period picker: 7d, 30d (the default), 90d or 12m. Every KPI computes its value over the
 * picked period and compares it with the same-length period right before it, which the picker says next to the
 * pills ("vs the previous 30 days"). OCA-E-159 pill segmented control (ITP-E-148-01).
 */
@Component({
  standalone: false,
  selector: 'app-admin-dashboard-period-picker',
  templateUrl: './admin-dashboard-period-picker.component.html',
  styleUrls: ['./admin-dashboard-period-picker.component.scss']
})
export class AdminDashboardPeriodPickerComponent {
  @Input() value = '30d';
  @Output() valueChange = new EventEmitter<string>();

  readonly options: AdminDashboardPeriodOption[] = [
    {key: '7d', label: '7d', long: '7 days'},
    {key: '30d', label: '30d', long: '30 days'},
    {key: '90d', label: '90d', long: '90 days'},
    {key: '12m', label: '12m', long: '12 months'}
  ];

  /** "vs the previous 30 days": what the picked period is compared with; empty for an unknown key. */
  get compareText(): string {
    const option = this.options.find(o => o.key === this.value);
    return option ? `vs the previous ${option.long}` : '';
  }

  onChange(value: string): void {
    if (value === this.value) {
      return;
    }
    this.value = value;
    this.valueChange.emit(value);
  }
}
